export default "__VITE_ASSET__CeX189Ob__"